// CORE
import React, { Component } from 'react'

// MODULES
import { 
	ModuleOne, 
	ModuleEleven,
	ModuleThirty, 
	ModuleThirtyOne,
	ModuleSeven,
	ModuleTwentyNine,
	ModuleFive } from '../../../components/Modules'
import Checkbox from '../../../components/Fields/Checkbox'

// STYLES
import classes from '../layout.css'

class FacialFractures extends Component {
	render() {
		const { addToForm, consentForm } = this.props

		return (
			<form id={consentForm.formId} className={classes.Container}>
				<h2>{consentForm.formName}</h2>

				<ModuleOne 
					addToForm={addToForm}
					consentForm={consentForm} 
				/>
				<ModuleEleven
					addToForm={addToForm}
					consentForm={consentForm} 
				/>
				<p><strong>Please initial each paragraph after reading. If you have any questions, please ask your doctor BEFORE initialing.</strong></p>
				<ModuleThirty 
					addToForm={addToForm}
					consentForm={consentForm}  
				/>
				<ModuleThirtyOne
					addToForm={addToForm}
					consentForm={consentForm} 
				/>
				<ModuleTwentyNine 
					addToForm={addToForm} 
					consentForm={consentForm} 
				/>
				<ModuleSeven 
					addToForm={addToForm} 
					consentForm={consentForm} 
				/>
				<h3>CONSENT</h3>
				
				<Checkbox
					controlFunc={addToForm}
					name={"consent"}
					consentForm={consentForm} 
					value={consentForm.consent}
				/>
				I have had an opportunity to have all my questions answered by my doctor. All the blanks on this form were filled in prior to my signing, and I certify that I speak, read and write English. My signature below signifies that I understand the surgery and anesthetic that is proposed for me, as well as the associated risks and possible complications. I give my consent for the surgery and the anesthesia which I have chosen. I accept the risks and possible complications involved.
				<ModuleFive 
					addToForm={addToForm} 
					consentForm={consentForm} 
				/>
			</form>
		)
	}
}

export default FacialFractures


// WEBPACK FOOTER //
// ./src/containers/FormLayout/Form/4.js